(function () {
  const initTmp2LeadReadMore = (root) => {
    root.querySelectorAll(".tmp2-lead.is-collapsible").forEach((block) => {
      if (block.dataset.tmp2LeadReady === "true") return;
      block.dataset.tmp2LeadReady = "true";

      const body = block.querySelector(".tmp2-lead__body");
      const button = block.querySelector("[data-tmp2-lead-more]");
      if (!body || !button) return;

      const collapsedRaw = getComputedStyle(block).getPropertyValue("--tmp2-lead-collapsed-h").trim();
      const collapsedMax = parseFloat(collapsedRaw) || 180;
      const labelMore = button.dataset.labelMore || "もっと読む";
      const labelLess = button.dataset.labelLess || "閉じる";

      const sync = () => {
        if (body.scrollHeight <= collapsedMax + 1) {
          block.classList.remove("is-clamped", "is-open");
          button.hidden = true;
          return;
        }
        block.classList.add("is-clamped");
        button.hidden = false;
      };

      button.addEventListener("click", () => {
        const open = block.classList.toggle("is-open");
        button.setAttribute("aria-expanded", open ? "true" : "false");
        const prefix = open ? "−" : "+";
        const label = open ? labelLess : labelMore;
        button.innerHTML = `<span class="tmp2-lead__more-mark" aria-hidden="true">${prefix}</span> ${label}`;
      });

      sync();
      if (typeof ResizeObserver !== "undefined") {
        const observer = new ResizeObserver(sync);
        observer.observe(body);
      }
    });
  };

  const boot = () => initTmp2LeadReadMore(document);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
